module.exports = __webpack_public_path__ + "static/icons/icon-chevron-right--white-3a07f8b21a5825a2e1c3dd485a781413.svg";